import { Controller } from '@hotwired/stimulus'

// Inline editing for the termination letter preview: the rendered letter is
// contenteditable, and leaving it (or clicking Save) syncs the text into the
// hidden form field and submits, so the preview IS the editor. The submit
// goes through Turbo, which re-renders the page with the saved letter.
export default class extends Controller {
  static targets = ['editor', 'field', 'form', 'hint']

  connect() {
    this.initial = this.editorTarget.innerText
  }

  changed() {
    const dirty = this.editorTarget.innerText !== this.initial
    if (this.hasHintTarget) this.hintTarget.classList.toggle('d-none', !dirty)
  }

  save() {
    if (this.editorTarget.innerText === this.initial) return

    this.fieldTarget.value = this.editorTarget.innerText
    this.initial = this.editorTarget.innerText
    this.formTarget.requestSubmit()
  }
}
